import React from "react";
import { AlertTriangle, Info, ExternalLink } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function SimilarWarning({ result, isMoneyOut, onContinue }) {
  if (!result || result.level === "none" || !result.matches?.length) return null;
  const strong = result.level === "duplicate";
  const title = strong
    ? "POSSIBLE DUPLICATE — PLEASE CHECK BEFORE SAVING"
    : `POSSIBLE SIMILAR ${isMoneyOut ? "PAYMENT" : "TRANSACTION"}`;
  return (
    <div
      data-testid="similar-warning"
      data-level={result.level}
      className={`rounded-xl border-2 p-4 ${strong ? "border-red-300 bg-red-50/70" : "border-amber-300 bg-amber-50/70"}`}
    >
      <div className={`flex items-center gap-2 text-xs font-bold tracking-wide ${strong ? "text-red-700" : "text-amber-800"}`} data-testid="similar-warning-title">
        {strong ? <AlertTriangle size={15} /> : <Info size={15} />} {title}
      </div>
      <div className="mt-3 space-y-2">
        {result.matches.map((m) => (
          <div key={m.id} className="bg-white/80 border border-slate-200 rounded-lg px-3 py-2 text-xs text-slate-700 flex flex-wrap items-center gap-x-4 gap-y-1" data-testid={`similar-match-${m.id}`}>
            <span className="font-semibold text-slate-900 tabular">{m.currency} {fmt(m.amount)}</span>
            {m.party_name && <span>{isMoneyOut ? "Paid To" : "Party"}: <b>{m.party_name}</b></span>}
            {m.pi_number && <span>PI: <b>{m.pi_number}</b></span>}
            <span>Date: <b className="tabular">{(m.transaction_date || "").slice(0, 10)}</b></span>
            {(m.company || m.account) && <span>{[m.company, m.account].filter(Boolean).join(" / ")}</span>}
            {m.reference && <span>Ref: <b>{m.reference}</b></span>}
            <span className="text-slate-500">Entered by {m.entered_by_name || "—"} on {(m.created_at || "").slice(0, 10)}</span>
            <a
              href={`/entry/${m.id}`}
              target="_blank"
              rel="noreferrer"
              data-testid={`similar-view-${m.id}`}
              className="ml-auto inline-flex items-center gap-1 text-[#0055FF] font-semibold hover:underline"
            >
              View existing <ExternalLink size={12} />
            </a>
          </div>
        ))}
      </div>
      <div className="mt-3 flex justify-end">
        <button
          type="button"
          onClick={onContinue}
          data-testid="similar-continue-btn"
          className="h-9 px-4 rounded-lg border border-slate-300 bg-white text-xs font-semibold text-slate-700 hover:bg-slate-50"
        >
          Continue with new transaction
        </button>
      </div>
    </div>
  );
}
